import useGetUserInfo from "./useGetUserInfo";

function useIsLoggedIn() {
  const { data: user } = useGetUserInfo();
  return !!user;
}

export default useIsLoggedIn;
